<!--添加/编辑充电桩 form表单-->
<template>
    <v-card :color="theme.elementBgColor" v-loading.fullscreen.lock="addLoading">
        <v-card-title>
            添加多个充电桩
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="6rem" label-position="top">
                <el-form-item label="站点" :rules="[{ required: true }]">
                    <select-site
                        ref="selectSite"
                        :selectSite="form.station_id"
                        @choose="chooseSite"
                        :width="'60%'"
                    />
                </el-form-item>
                <!-- <el-form-item label="互联互通">
                    <select-cec :width="'60%'" :cecId="form.cec_id" @chooseCec="chooseCec" />
                </el-form-item> -->
                <el-form-item label="几号桩开始" :rules="[{ required: true }]">
                    <el-tooltip class="item" effect="dark" content="包含此编号桩" placement="top">
                        <el-input-number
                            v-model="form.start"
                            controls-position="right"
                            :min="1"
                        ></el-input-number>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="桩的数量 N" :rules="[{ required: true }]">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="最少2个，最多40个"
                        placement="top"
                    >
                        <el-input-number
                            v-model="form.n"
                            controls-position="right"
                            :min="2"
                            :max="40"
                        ></el-input-number>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="设备名称" :rules="[{ required: true }]">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="取需要添加桩的前置相同名称"
                        placement="top"
                    >
                        <el-input v-model="form.name" autocomplete="off" style="width: 60%">
                            <span slot="append">N 号桩</span>
                        </el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="设备编码" :rules="[{ required: true }]">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="取需要添加桩的前置相同数值"
                        placement="top"
                    >
                        <el-input
                            v-model="form.cec_equipment_id"
                            autocomplete="off"
                            @input="inputSerial"
                            style="width: 60%"
                        >
                            <span slot="append">N</span>
                        </el-input>
                    </el-tooltip>
                    <div class="repeat_div" v-if="isShowRepeatDiv" style="width: 60%">
                        <div
                            class="repeat_text"
                            v-for="(item, index) in repeatEquipmentId"
                            :key="index"
                        >
                            {{ item }}
                            <span style="padding: 0 0 0 1rem">
                                <i class="el-icon-close"></i>
                                已存在
                            </span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="额定功率" :rules="[{ required: true }]">
                    <el-input v-model="form.power" autocomplete="off" style="width: 33%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="设备类型" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import SelectCec from "@/components/SelectCec";
import { mapState } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            form: {
                n: null, //桩的数量
                start: null, //几号桩开始添加
                name: null,
                cec_equipment_id: null,
                cec_id: null,
                power: null,
                station_id: null,
                type: null,
            },
            equipmentIdArray: null, //选中站点下的设备序列号数组
            typeText: [
                {
                    id: 1,
                    value: "直流设备",
                },
                {
                    id: 2,
                    value: "交流设备",
                },
                {
                    id: 3,
                    value: "交直流一体设备",
                },
                {
                    id: 4,
                    value: "无线",
                },
                {
                    id: 5,
                    value: "其他",
                },
            ],
            paramsArr: [], //提交请求参数数组
            repeatEquipmentId: [], //重复的充电桩id数组
            isShowRepeatDiv: false, //是否显示重复桩编号框
            requestError: [], //批量请求错误的参数
            addLoading: false,
        };
    },
    watch: {
        station_id: {
            handler(val) {
                if (val) {
                    this.form["station_id"] = val;
                }
            },
            deep: true,
        },
        repeatEquipmentId: {
            handler(val) {
                if (val.length > 0) {
                    this.isShowRepeatDiv = true;
                } else {
                    this.isShowRepeatDiv = false;
                }
            },
            deep: true,
        },
    },
    props: {
        station_id: Number,
    },
    updated() {
        this.$refs.selectSite.site = this.form["station_id"];
    },
    mounted() {
        this.form["station_id"] = this.station_id;
    },
    components: {
        SelectSite,
        SelectPile,
        SelectCec,
    },
    computed: {
        ...mapState(["equipmentInfo", "contactInfo", "TipType", "theme"]),
    },
    methods: {
        chooseCec(cecId) {
            this.form["cec_id"] = cecId;
        },
        async chooseSite(site) {
            if (site.cecId) {
                this.form["cec_id"] = site.cecId;
            } else {
                this.form["cec_id"] = null;
            }
            this.form["station_id"] = site.siteId;
            let postData = {
                station_id: site.siteId,
            };
            await store.dispatch("getEquipment", postData);
        },
        /*获取充电桩数据 用户判断是否存在相同的充电桩编号*/
        async getEquipmentInfo() {
            let postData = {
                station_id: this.form["station_id"],
            };
            await store.dispatch("getEquipment", postData);
            this.equipmentIdArray = [];
            for (let i = 0; i < this.equipmentInfo.length; i++) {
                this.equipmentIdArray.push(this.equipmentInfo[i].cec_equipment_id);
            }
        },
        /*确定添加或者修改设备*/
        async determine() {
            this.addLoading = true;
            this.paramsArr = [];
            this.repeatEquipmentId = [];
            let form = Object.assign({}, this.form);
            delete form.cec_id;
            let nullKeyArr = Object.keys(form).filter(key => !form[key]);
            if (nullKeyArr.length > 0) {
                let utilText = "";
                for (let i1 = 0; i1 < nullKeyArr.length; i1++) {
                    if (i1 == nullKeyArr.length - 1) {
                        utilText = utilText + this.utilText(nullKeyArr[i1]);
                    } else {
                        utilText = utilText + this.utilText(nullKeyArr[i1]) + "、";
                    }
                }
                util.ShowTip(utilText + "不能为空", 3);
                this.addLoading = false;
                return;
            }
            await this.dealData(this.form.n);
            await this.getEquipmentInfo();
            let MoreEquipmentIdArray = [];
            for (let i2 = 0; i2 < this.paramsArr.length; i2++) {
                MoreEquipmentIdArray.push(this.paramsArr[i2].postData.cec_equipment_id);
            }
            for (let i3 = 0; i3 < MoreEquipmentIdArray.length; i3++) {
                for (let i4 = 0; i4 < this.equipmentIdArray.length; i4++) {
                    if (MoreEquipmentIdArray[i3] == this.equipmentIdArray[i4]) {
                        this.repeatEquipmentId.push(MoreEquipmentIdArray[i3]);
                    }
                }
            }
            this.repeatEquipmentId.reverse();
            if (this.repeatEquipmentId.length > 0) {
                this.addLoading = false;
                return;
            }
            await this.addEquipment(this.paramsArr.length);
            // console.log(this.paramsArr);
            // console.log(this.requestError);
        },
        async addEquipment(i) {
            // console.log("第" + i + "请求添加，请求参数是：");
            let nextI = i - 1;
            this.paramsArr[nextI].i = nextI;
            // console.log(this.paramsArr[nextI]);
            await store.dispatch("addMoreEquipment", this.paramsArr[nextI]);
        },
        /*充电桩编号改变*/
        inputSerial(e) {
            // console.log(e);
        },
        /*返回相应为空值指的文本*/
        utilText(key) {
            let text = "";
            if (!this.form[key]) {
                if (key == "station_id") {
                    text = "站点";
                }
                if (key == "power") {
                    text = "额定功率";
                }
                if (key == "type") {
                    text = "设备类型";
                }
                if (key == "name") {
                    text = "设备名称";
                }
                if (key == "cec_equipment_id") {
                    text = "设备编码";
                }
            }
            return text;
        },
        /*处理批量数据*/
        dealData(num) {
            let params = {
                postData: {
                    equipment: {},
                },
                i: null,
                callbackError: params => {
                    this.requestError.push(params);
                },
                callbackOK: i => {
                    if (i > 0) {
                        this.addEquipment(i);
                    } else {
                        if (this.requestError.length == 0) {
                            util.ShowTip("全部添加成功", 1);
                            this.cancel();
                            this.$emit("refresh");
                        } else {
                            for (let i = 0; i < this.requestError.length; i++) {
                                this.$notify({
                                    title: "警告",
                                    dangerouslyUseHTMLString: true,
                                    message:
                                        "添加失败!!!" +
                                        "<br/>名称：" +
                                        this.requestError[i].postData.equipment.name +
                                        "<br/>编号：" +
                                        this.requestError[i].postData.equipment.cec_equipment_id,
                                    type: "warning",
                                    duration: 0,
                                    offset: 55 * i,
                                    position: "bottom-right",
                                });
                            }
                        }
                        this.addLoading = false;
                    }
                },
            };
            params.postData.equipment["station_id"] = this.form["station_id"];
            params.postData.equipment["power"] = this.form["power"];
            params.postData.equipment["type"] = this.form["type"];
            params.postData.equipment["name"] = Public.removeSpace(
                this.form["name"] + (this.form["start"] + num - 1).toString() + "号桩"
            );
            params.postData.equipment["cec_equipment_id"] = Public.removeSpace(
                this.form["cec_equipment_id"] + this.judge(Number(this.form["start"] + num - 1))
            );
            params.postData.equipment["cec_id"] = this.form["cec_id"];

            this.paramsArr.push(params);
            if (num - 1 != 0) {
                this.dealData(num - 1);
            }
        },
        /*将1变成01*/
        judge(value) {
            if (value >= 10) {
                return value.toString();
            } else if (value > 0 && value < 10) {
                return "0" + value.toString();
            }
        },
        /*取消添加设备*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                if (key != "station_id") {
                    this.form[key] = null;
                }
            });
            this.$emit("cancel");
        },
        /*去除前后空格*/
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
<style scoped>
.repeat_div {
    height: 7rem;
    border: 1px solid #d9d9d9;
    padding: 0.5rem;
    overflow: auto;
}
.repeat_text {
    width: 100%;
    height: 1.5rem;
    /* background-color: red; */
    color: red;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
}
</style>
